import { render, staticRenderFns } from "./new_report_whole.vue?vue&type=template&id=d5c10b0e&scoped=true&"
import script from "./new_report_whole.vue?vue&type=script&lang=js&"
export * from "./new_report_whole.vue?vue&type=script&lang=js&"
import style1 from "./new_report_whole.vue?vue&type=style&index=1&id=d5c10b0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c10b0e",
  null
  
)

export default component.exports